import { AppState } from './store';

export const selectDeviceEventsState = (state: AppState) => state['device-events'];

export const selectDeviceEventMediaState = (state: AppState) => state['device-event-media'];
